export const environment = {
  production: false,
  azureConfig: {
    redirectUri: 'https://adm-ambientes-qa.apps.ambientesbc.com/',
    clientId: '5ac1af94-b9f5-48cf-b5a3-53836860c714',
    tenantId: '428f4e2e-13bf-4884-b364-02ef9af41a1d',
    loginMicrosoft: 'https://login.microsoftonline.com',
    appScope: `api://5ac1af94-b9f5-48cf-b5a3-53836860c714/default`,
    sendTokenTo: {
      'https://ingenieriati-ext-qa.apps.ambientesbc.com': [
        `api://5ac1af94-b9f5-48cf-b5a3-53836860c714/default`,
      ],
    },
  },
  config: {
    endpoints: {
      BOK: 'https://ingenieriati-ext-qa.apps.ambientesbc.com/admin-de-ambientes-mig/apibooking',
      SFM: 'https://ingenieriati-ext-qa.apps.ambientesbc.com/admin-de-ambientes-mig/apiselfmanagement',
      TGI: 'https://ingenieriati-ext-qa.apps.ambientesbc.com/admin-de-ambientes-mig/appincident',
      ADA: 'https://ingenieriati-ext-qa.apps.ambientesbc.com/admin-de-ambientes-mig',
      CONCURRENCY:
        'https://prod-76.westus.logic.azure.com:443/workflows/d8c4b9c7d6ef48afa81b038798db1e45/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=MeJjGlxjw37934gmmFG8a27FJVK8KiuhEALPBDFKO2k',
      NOTIFICATIONS:
        'https://prod-150.westus.logic.azure.com:443/workflows/4ffc47ffd77244018a8c38e3693bdc8d/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=vUDn1TrcXsy9VEXw2C-nmk7m06YSHoP3wgG5C5uA6aI',
    },
  },
};
